let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("49cM0")).then(() => parcelRequire('cAQ2R'));